import { useState } from "react";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import {
  Box,
  Flex,
  Heading,
  Text,
  FormControl,
  FormLabel,
  Input,
  Button,
  CircularProgress,
  Center,
  Image,
  InputRightElement,
  InputGroup,
  HStack,
  Spacer,
} from "@chakra-ui/react";
import axios from "axios";
import Joi from "joi";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { SET_USER } from "../../store/auth/authActionType";
import validator from "validator";
import Select from "react-select";
import {
  extractAuthTokenFromHeaders,
  setAuthToken,
} from "../../utils/auth";

const loginSchema = Joi.object({
  email: Joi.string().custom((v) => {
    if (validator.isEmail(v)) {
      return v;
    }
    const phoneRegex = /^\+([0-9]{1,3})\)?[\s]?[0-9]{6,14}$/;
    if (phoneRegex.test(v)) {
      return v;
    }
    throw new Error("Please Provide valid data");
  }),
  password: Joi.string().required(),
});
function Login() {
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [role, setRole] = useState({ value: "ADMIN", label: "Admin" });
  const option: any = [
    { value: "ADMIN", label: "Admin" },
    { value: "SUB_ADMIN", label: "Sub Admin" },
  ];

  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const login = () => {
    const data = {
      email,
      password,
    };
    // console.log(data);

    if (loginSchema.validate(data).error) {
      if (
        loginSchema.validate(data).error?.message ===
        `"email" is not allowed to be empty`
      ) {
        setErrorMsg("Please enter Email / Phone");
      } else if (
        loginSchema.validate(data).error?.message ===
        `"password" is not allowed to be empty`
      ) {
        setErrorMsg("Please enter Password");
      } else if (
        loginSchema.validate(data).error?.message ===
        `"email" failed custom validation because Please Provide valid data`
      ) {
        setErrorMsg("Please enter valid Email / Phone");
      }
      setIsSubmitting(false);
      return;
    } else {
      const payloadValue = loginSchema.validate(data).value;
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/admin/auth/login`,
          {
            email: payloadValue.email,
            password: payloadValue.password,
            // role: role.value,
          },
          {
            //withCredentials: true,
            // headers: {
            //   "Access-Control-Allow-Credentials": "true",
            // },
          }
        )
        .then((res) => {
          const token = extractAuthTokenFromHeaders(res.headers);
          if (!token) {
            setIsSubmitting(false);
            setErrorMsg("Login succeeded but no auth token was returned.");
            return;
          }
          setAuthToken(token);
          // if (res.data.userType !== "ADMIN") {
          //   alert("only admin can login");
          // }
          dispatch({ type: SET_USER, payload: res.data });
          let userData: any = {
            firstName: res.data.firstName,
            lastName: res.data.lastName,
            email: res.data.email,
            _id: res.data._id,
            userType: res.data.userType,
          };
          localStorage.setItem("userDataa", JSON.stringify(userData));

          navigate("../");
          // let userData: any = {
          //   userName: res.data.data.userName,
          //   firstName: res.data.data.firstName,
          //   lastName: res.data.data.lastName,
          //   email: res.data.data.email,
          //   _id: res.data.data._id,
          //   userType: res.data.data.userType,
          //   userRole: res.data.data.userRole,
          //   profileImage: res.data.data.profileImage,
          //   phone: res.data.data.phone,
          // };
        })
        .catch((error) => {
          setIsSubmitting(false);
          if (error === "Error: Network Error") {
            setErrorMsg(
              "Something went wrong, please try again after some time or Refresh the Page."
            );
          } else if (error.response.status === 401) {
            setErrorMsg(error.response.data.message);
          } else if (error.response.status === 500) {
            setErrorMsg("Something happened wrong try again after sometime.");
          } else if (error.response.status === 422) {
            setErrorMsg(error.response.data.message);
          } else if (error.response.status === 415) {
            setErrorMsg(error.response.data.message);
          }
        });
    }
  };
  return (
    <Flex
      minHeight="100vh"
      width="full"
      align="center"
      justifyContent="center"
      gap={10}
      background="#F9F9F9"
      padding={"50px"}
    >
      <div
        style={{
          width: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          borderWidth={1}
          px={4}
          width="full"
          maxWidth="400px"
          borderRadius={"10px"}
          textAlign="center"
          border={"none"}
          // boxShadow="lg"
          background={"white"}
        >
          <Box p={4}>
            <Box>
              <Image
                src="/logo.svg"
                alt="AI"
                margin={"10px auto"}
                align="center"
              />
              <Text>
                <br></br>
              </Text>
              <Heading textAlign={"left"} mb={5} fontSize="27px">
                Sign In
              </Heading>
              <Text textAlign={"left"} color="red">
                {errorMsg}
              </Text>
            </Box>
            <Box mb={8} mt={2} textAlign="left">
              <FormControl isRequired>
                <FormLabel>Email address </FormLabel>
                <Input
                  type="email"
                  placeholder="Enter your Email"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </FormControl>

              <FormControl mt={4} isRequired>
                <FormLabel>Password</FormLabel>
                <InputGroup size="md">
                  <Input
                    type={show ? "text" : "password"}
                    placeholder="Enter your password"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        setIsSubmitting(true);
                        login();
                      }
                    }}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <InputRightElement width="4.5rem">
                    <Box cursor={"pointer"} onClick={handleClick}>
                      {show ? <IoEyeOffOutline /> : <IoEyeOutline />}
                    </Box>
                  </InputRightElement>
                </InputGroup>
              </FormControl>

              {/* <FormControl mt={4} isRequired>
                <Flex width="100%">
                  <HStack>
                    <FormLabel>Login as a </FormLabel>
                    <Spacer></Spacer>
                   
                  </HStack>
                </Flex>
                <Select
                  // isDisabled={isDisabled}
                  value={role}
                  name="category"
                  onChange={(event: any) => {
                    setRole(event);
                  }}
                  options={option}
                  placeholder="Select admin"
                />
              </FormControl> */}

              {isSubmitting ? (
                <Flex
                  bg="white.500"
                  color="gery.500"
                  width="full"
                  justifyContent="center"
                  mt={4}
                >
                  <Center>
                    <CircularProgress
                      size={7}
                      isIndeterminate
                      color="green.500"
                      m={1}
                    />
                  </Center>
                </Flex>
              ) : (
                <Button
                  bg="#000"
                  color="white"
                  width="full"
                  mt={5}
                  onClick={() => {
                    setIsSubmitting(true);
                    login();
                  }}
                  _hover={{
                    bg: "#000",
                    color: "white",
                  }}
                >
                  Sign In
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </div>
      {/* <Box width="50%">
        <Image
          src="/loginbg.png"
          alt="AI"
          objectFit="cover"
          maxWidth="100%"
          align="center"
          maxHeight="80vh"
        />
      </Box> */}
    </Flex>
  );
}

export default Login;
